import(/* webpackMode: "eager" */ "/home/ubuntu/app/hellojob-pro/src/app/viec-lam/page.tsx");
